const doc = [({"da":({"js":({"admin":({"plans":({"show":({"show_plan":"Vis plan: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;